import React, { useEffect, useState } from 'react';
import {
  bool, number, oneOf, oneOfType, string
} from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import classNames from 'classnames';
import styles from './video-player.module.scss';

export const VideoPlayer = ({
  aspectRatio,
  autoPlay,
  className,
  height,
  videoId,
  videoSrc,
  videoStill,
  width
}) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('video-player.ready');
  });

  const [enableVideoStill, setEnableVideoStill] = useState(!!videoStill);

  const containerStyle = {
    width,
    maxWidth: width,
  };

  const videoStillWrapperStyle = classNames(
    styles['video-player__wrapper'],
    styles['video-player__wrapper--still']
  );

  const playButtonStyles = classNames(
    styles['video-player__play-button']
  );

  if (enableVideoStill) {
    return (
      <div className={styles['video-player__container']} style={containerStyle}>
        <div className={videoStillWrapperStyle}>
          <Image
            alt="thumbnail"
            className={styles['video-player__still']}
            height={height}
            src={videoStill}
            width={width}
          />
          <button
            alt="Play Button"
            aria-label="play video"
            className={playButtonStyles}
            onClick={() => setEnableVideoStill(false)}
            type="button"
          />
        </div>
      </div>
    );
  }

  if (videoSrc) {
    return (
      <div className={styles['video-player__container']} style={containerStyle}>
        <iframe
          className={className}
          src={`${videoSrc}?autoplay=true`}
          title={videoSrc}
          allow="autoplay"
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          height={height}
          width={width}
        />
      </div>
    );
  }

  let iframeSrc = `https://players.brightcove.net/66036796001/4JE-ofbdg_default/index.html?videoId=${videoId}`;
  iframeSrc += autoPlay || videoStill ? '&autoplay=any&playsinline=true' : '';

  const videoWrapperStyle = classNames(
    styles['video-player__wrapper'],
    styles['video-player__responsive'],
    {
      [styles['video-player__responsive--16-9']]: aspectRatio === 16 / 9,
      [styles['video-player__responsive--4-3']]: aspectRatio === 4 / 3,
    }
  );

  return (
    <div className={styles['video-player__container']} style={containerStyle}>
      <div className={videoWrapperStyle}>
        <iframe
          className={classNames(styles['video-player'], className)}
          height={height}
          src={iframeSrc}
          title={videoId}
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          width={width}
        />
      </div>
    </div>
  );
};

VideoPlayer.propTypes = {
  aspectRatio: oneOf([16 / 9, 4 / 3]),
  autoPlay: bool,
  className: string,
  height: number,
  videoId: oneOfType([string, number]).isRequired,
  videoSrc: string,
  videoStill: string,
  width: number
};

VideoPlayer.defaultProps = {
  aspectRatio: 16 / 9,
  autoPlay: false,
  className: null,
  height: null,
  videoSrc: null,
  videoStill: null,
  width: null
};
